import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Button from "@ROM-ui/Button";
import { ship } from "@ROM/DeliveryStatuses/actions";

const Ship = ({ delivery, setError }) => {
  const dispatch = useDispatch();
  const handleShip = (e) => {
    e.stopPropagation();
    dispatch(ship({ deliveryId: delivery.id })).then((response) => {
      if (response.payload.status !== 201) {
        setError(true);
      }
    });
  };

  return (
    <>
      <Button variant="outline-success" className="ms-2 px-2" size="sm" onClick={handleShip}>
        Mark as Shipped
      </Button>
    </>
  );
};

Ship.propTypes = {
  delivery: PropTypes.shape({ id: PropTypes.number }).isRequired,
  setError: PropTypes.func.isRequired,
};

export default Ship;
